<template>
    <v-dialog v-model="dialog" width="600px">
        <v-card class="pa-3">
            <v-card-title>Add a discount to {{ huis.huis_code }} <v-spacer></v-spacer><v-btn x-small @click="showBookingDates = !showBookingDates" v-if="!showBookingDates">Extra fields modus</v-btn>
            </v-card-title>
            
            <v-form ref="addHsab2">
                <!-- valid from - until -->
                <v-row no-gutters>
                    <v-col cols="6" class="pa-2">
                        <date_picker label="Stay starts"                                 
                                     :date="hsabFromDate"
                                     :startDate="hsabFromDate"
                                     field="hsabFromDate" 
                                     hint="Only enter a date if applicable" 
                                     icon="mdi-calendar-month-outline"
                                     :manual="true" 
                                     @updateData="updateData"/> 
                    </v-col>
                    <v-col cols="6" class="pa-2">
                        <date_picker label="Stay ends"                                 
                                     :date="hsabUntilDate"
                                     :startDate="hsabFromDate"
                                     field="hsabUntilDate" 
                                     hint="Only enter a date if applicable" 
                                     icon="mdi-calendar-month-outline"
                                     :manual="true" 
                                     @updateData="updateData"/>                                      
                    </v-col>
                </v-row>
                <!-- booking from - until -->
                              
                <v-row no-gutters v-if="showBookingDates">
                    <v-col cols="6" class="pa-2">
                        <date_picker label="Booking date from"                                 
                                    :date="hsabBookingDateFrom"
                                    :startDate="hsabBookingDateFrom"
                                    field="hsabBookingDateFrom" 
                                    hint="Only enter a date if applicable" 
                                    icon="mdi-calendar-month-outline"
                                    :manual="true" 
                                    @updateData="updateData"/> 
                    </v-col>
                    <v-col cols="6" class="pa-2">
                        <date_picker label="Booking date until"                                 
                                    :date="hsabBookingDateUntil"
                                    :startDate="hsabBookingDateFrom"
                                    field="hsabBookingDateUntil" 
                                    hint="Only enter a date if applicable" 
                                    icon="mdi-calendar-month-outline"
                                    :manual="true" 
                                    @updateData="updateData"/> 
                    </v-col>
                </v-row>
        
                        <v-row no-gutters>
                    <v-col class="pa-2">
                        <v-text-field v-model="huis.hsab_kort_perc_verkoop" label="Discount % Guest"
                            suffix="%"></v-text-field>
                    </v-col>
                    <v-col class="pa-2" v-if="showBookingDates">
                        <v-text-field v-model="huis.hsab_kort_perc_inkoop" label="Discount % Host"
                            suffix="%"></v-text-field>
                    </v-col>
                </v-row>

            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addHsab2">Save</v-btn>
                <v-btn color="primary" small @click="closeDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

// import { bus } from "../../../main";
import date_picker from '@/components/ui/date_picker.vue';

export default {

    data() {
        return {
            dialog: false,
            huis_encrid: null,
            nacht_nrKeuzes: [],
            huis: {},
            hsabFromDate: null, 
            hsabUntilDate: null,
            hsabBookingDateFrom: null,
            hsabBookingDateUntil: null,
            showBookingDates: false,
        }
    },
    components: {
        date_picker,
    },
    watch: {
        'huis.hsab_kort_perc_verkoop': {
            handler(newVal) {
            this.huis.hsab_kort_perc_inkoop = newVal;
            }
        }
    },
    methods: {
        updateData(data){
            //console.log('updateData', data);
            this[data.field] = data.value;
        },
        closeDialog(){
            this.$refs.addHsab2.reset();
            this.showBookingDates = false;
            this.$emit("updateData");
            this.dialog = false;
        },
        open(huis_encrid) {

            this.$emit("showSnackbar");        
            this.huis_encrid = huis_encrid
            this.hsabFromDate = null 
            this.hsabUntilDate = null
            this.hsabBookingDateFrom = null
            this.hsabBookingDateUntil = null
            this.$axios
                .post("ares/json/ares/huis/hsab/getHuisToAddHsab.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisToAddHsab"
                    },
                    getHuisToAddHsab: {
                        huis_encrid: huis_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.huis = res.data.getHuisToAddHsab;
                        this.nacht_nrKeuzes = res.data.getHuisToAddHsab.nacht_nrKeuzes;
                    }
                })
                .finally(() => {
                    this.dialog = true;
                });
        },
        addHsab2() {
            this.$axios
                .post("ares/json/ares/huis/hsab/addHsab.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHsab"
                    },
                    addHsab: {
                        huis_encrid: this.huis.huis_encrid,
                        hsab_verb_van_dat: this.hsabFromDate,
                        hsab_verb_tm_dat: this.hsabUntilDate,
                        hsab_boek_van_dat: this.hsabBookingDateFrom,
                        hsab_boek_tm_dat: this.hsabBookingDateUntil,
                        hsab_advb_van: 9999,
                        hsab_advb_tm: 0,
                        hsab_aant_nacht_van: 2,
                        hsab_aant_nacht_tm: 28,
                        hsab_kort_perc_verkoop: parseFloat(this.huis.hsab_kort_perc_verkoop),
                        hsab_kort_perc_inkoop: parseFloat(this.huis.hsab_kort_perc_inkoop)
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        // if (res.data.addHsab.color == "success") {
                        //     //this.$router.reload('/huis/onHuis/' + res.data.addHsab.huis_encrid);  
                        //     //this.$refs.getHuisDiscounts();
                        //     bus.$emit("closeDialog", "reload");
                        // }
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHsab.text,
                            color: res.data.addHsab.color
                        });
                        this.closeDialog();
                    }
                })
        }
    }
}
</script>

